import {Injectable} from '@angular/core';
import {FgiBackEndService} from '../../shared/fgi-back-end.service';

@Injectable({
  providedIn: 'root',
})
export class EcgPorTerceirosService extends FgiBackEndService<any> {

  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/';
  }
}
